export const countUp = () => {
    const elements = document.querySelectorAll('[vdx-count-up]');

    // Helper function to animate the count
    const startCount = (element) => {
        const targetValue = +element.textContent.trim();
        const duration = +element.getAttribute('vdx-count-up') || 2000;
        const easeType = element.getAttribute('vdx-count-ease') || 'linear';
        let startTime = null;

        // Easing functions
        const easingFunctions = {
            linear: t => t,
            easeInQuad: t => t * t,
            easeOutQuad: t => t * (2 - t),
            easeInOutQuad: t => t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t,
            easeInCubic: t => t * t * t,
            easeOutCubic: t => (--t) * t * t + 1,
            easeInOutCubic: t => t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
            easeInQuart: t => t * t * t * t,
            easeOutQuart: t => 1 - (--t) * t * t * t,
            easeInOutQuart: t => t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t,
            easeInQuint: t => t * t * t * t * t,
            easeOutQuint: t => 1 + (--t) * t * t * t * t,
            easeInOutQuint: t => t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t,
            easeOutExpo: t => (t === 1) ? 1 : 1 - Math.pow(2, -10 * t)
        };

        // Get the easing function or default to linear
        const ease = easingFunctions[easeType] || easingFunctions.linear;

        const animateCount = (timestamp) => {
            if (!startTime) startTime = timestamp;
            const linearProgress = Math.min((timestamp - startTime) / duration, 1);
            const easedProgress = ease(linearProgress);
            element.textContent = Math.floor(easedProgress * targetValue);

            if (linearProgress < 1) {
                requestAnimationFrame(animateCount);
            } else {
                element.textContent = targetValue; // Ensure final value is exact
            }
        };

        requestAnimationFrame(animateCount); // Start the animation
    };

    // Set up the IntersectionObserver
    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                startCount(entry.target); // Start count when element comes into view
                observer.unobserve(entry.target); // Stop observing once counted
            }
        });
    });

    // Observe each element with the [vdx-count-up] attribute
    elements.forEach(observer.observe.bind(observer));
};
